module.exports = __webpack_public_path__ + "img/bcard_7.e32e09fc.png";